"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
interface Author {
  id?: string | null;
  name?: string | null;
  slug?: string | null;
  avatarUrl?: string | null;
}
export interface PostAuthorsProps {
  /**
   * Array of populated authors from the post
   */
  authors?: Author[] | null;
  /**
   * Additional CSS classes for the container
   */
  className?: string;
  /**
   * Localized label for singular "Author"
   */
  authorLabel: string;
  /**
   * Localized label for plural "Authors"
   */
  authorsLabel: string;
}

/**
 * Displays post authors with localized "Author/Authors" label.
 * Each author name links to /authors/<slug> when slug is present.
 */
export function PostAuthors(t0) {
  const $ = _c(21);
  const {
    authors,
    className: t1,
    authorLabel,
    authorsLabel
  } = t0;
  const className = t1 === undefined ? "mt-8" : t1;
  const urlBuilder = useNavigation();
  if (!authors || authors.length === 0) {
    return null;
  }
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== authorLabel || $[1] !== authors || $[2] !== authorsLabel || $[3] !== className || $[4] !== urlBuilder) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const validAuthors = authors.filter(_temp);
      if (validAuthors.length === 0) {
        t8 = null;
        break bb0;
      }
      const label = validAuthors.length === 1 ? authorLabel : authorsLabel;
      t7 = className;
      t2 = "text-sm text-foreground/60";
      t3 = label;
      t4 = ":";
      t5 = " ";
      t6 = validAuthors.map((author, idx) => {
        const isLast = idx === validAuthors.length - 1;
        const separator = isLast ? "" : ", ";
        if (author.slug) {
          return <span key={author.id ?? idx}><Link prefetch={false} href={urlBuilder.author(author.slug)} className="hover:underline">{author.name}</Link>{separator}</span>;
        }
        return <span key={author.id ?? idx}>{author.name}{separator}</span>;
      });
    }
    $[0] = authorLabel;
    $[1] = authors;
    $[2] = authorsLabel;
    $[3] = className;
    $[4] = urlBuilder;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t9 = <p className={t2}>{t3}{t4}{t5}{t6}</p>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <div className={t7}>{t9}</div>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function _temp(a) {
  return Boolean(a?.name);
}